<div id="{{idPrefix}}" class="container-fluid pb-3">
     <workflow-target [target]="WorkflowTarget.SMP_CASE" [idPrefix]="idPrefix"></workflow-target>
</div>
